// extracted by mini-css-extract-plugin
module.exports = {"cls1":"AccessoryIndex-AccessoryTabWrapper-module--cls1--p3M6j"};